module.exports = __webpack_public_path__ + "img/header-uz.e00310e7.jpg";